// src/components/Step3.js
import React, { useState,useEffect } from 'react';

import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProgressMessage from './ProgressMessage';
import '../css/Step3.css';


const BulkDBConversion = () => {
	const [statusMessage, setStatusMessage] = useState('대기중...');
	const [isConverting, setIsConverting] = useState(false);
	const [isFinished, setIsFinished] = useState(false);
	const [animatedText , setAnimatedText] = useState('');

	const fullText = 'Korean DB => Japanese DB'; // Full text to animate

	// Effect to animate the text
  useEffect(() => {
    if (isConverting) {
      let currentIndex = 0;

      // Timer to animate text
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;

        if (currentIndex === fullText.length) {
          currentIndex = 0; // Restart animation
        }
      }, 150); // Adjust speed here

      return () => clearInterval(timer); // Clean up on unmount or stop
    } else {
      setAnimatedText(fullText); // Reset text when not extracting
    }
  }, [isConverting]);
	
	const handleStartConvert = () => {
		setIsConverting(true);
		setStatusMessage('Products DB 변환 중...');

		axios.post('http://localhost:5000/convert-product/convert-db-products')
			.then(response => {
				setStatusMessage('Products DB 변환 완료.');
				
				const details = response.data.details;
				const lastLine = details.trim().split('\n').pop();

				if(lastLine === 'Fill Category Table'){
					setStatusMessage("카테고리 DB가 비어있습니다. 카테고리 DB 변환을 실행해주십시오. ");
					setIsConverting(false);
					return ;
				}else {
					setTimeout(() => {
						convertOptionsTable();
					}, 500)
				}


			})
			.catch(error => {
				console.error('Error during conversion:', error);
				setStatusMessage('상품 DB 변환 중 오류가 발생했습니다.');
				setIsConverting(false);
			});
	};
	const convertOptionsTable = () => {
		setIsConverting(true);
		setStatusMessage("Options DB 변환 중...");

		axios.post('http://localhost:5000/convert-product/convert-db-options')
			.then(response => {
				setStatusMessage("Options DB 변환 완료.");
				
        setIsConverting(false); // 자동번역 없을때만 사용
        setIsFinished(true); // 자동번역 없을때만 사용
        setTimeout(() => {
					convertMulitiImagesTable();  // 이미지 테이블 
				}, 500)
			})
			.catch(error => {
				console.log("Error During Conversion : ", error);
				setStatusMessage("Options DB 변환중 오류가 발생했습니다. ");
				setIsConverting(false);
			})
	}

	const convertMulitiImagesTable = () => {
		setIsConverting(true);
		setStatusMessage("MultiImages DB 변환 중...");

		axios.post('http://localhost:5000/convert-product/convert-db-multiImages')
			.then(response => {
				setStatusMessage("MultiImages DB 변환 완료. ");
				setTimeout(() => {
          translateProductsTable(); // 자동번역 잠깐 중지 
				}, 500);

			})
			.catch(error => {
				console.log("Error During Conversion : ", error);
				setStatusMessage("Images DB 변환중 오류가 발생했습니다. ");
				setIsConverting(false); 
			})
	}

  const translateProductsTable = () => {
    setIsConverting(true);
		setStatusMessage("상품 DB 번역 진행중...");

		axios.post('http://localhost:5000/convert-product/translate-db-products')
			.then(response => {
				setStatusMessage("상품 DB 번역 완료. ");
				setTimeout(() => {
					setStatusMessage("상품 DB Conversion 완료");
          translateOptionsTable();
				}, 500);

			})
			.catch(error => {
				console.log("Error During Conversion : ", error);
				setStatusMessage("상품 DB 번역중 오류가 발생했습니다. ");
				setIsConverting(false);
			})
  }

  const translateOptionsTable =() => {
    setIsConverting(true);
		setStatusMessage("옵션 DB 번역 진행중...");

		axios.post('http://localhost:5000/convert-product/translate-db-options')
			.then(response => {
				setStatusMessage("옵션 DB 번역 완료. ");
				setTimeout(() => {
					setStatusMessage("옵션 DB Conversion 완료");
					setIsConverting(false);
					setIsFinished(true);
				}, 500);

			})
			.catch(error => {
				console.log("Error During Conversion : ", error);
				setStatusMessage("옵션 DB 번역중 오류가 발생했습니다. ");
				setIsConverting(false);
			})
  }

	return (
		<motion.div
			className="step-container"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<h2>Conversion Product DB</h2>
			<p className={`animated-text ${isConverting ? 'extracting' : ''}`}>
        {animatedText}
      </p>
			<div className="conversion-container">
				<button
					onClick={handleStartConvert}
					className="convert-button"
					disabled={isConverting}
				>
					Convert and Translate
				</button>
        <button
					onClick={translateProductsTable}
					className="convert-button"
					disabled={isConverting}
				>
					Translate(Temp)
				</button>

				<ProgressMessage message={statusMessage} />
				{isFinished && <Link to="/bulk-csv-export" className="next-button">Next</Link>}
			</div>
		</motion.div>
	);
};

export default BulkDBConversion;
